export const GET_ALL_CHECKERS = "GET_ALL_CHECKERS"
export const CREATE_CHECKER = "CREATE_CHECKER"
export const UPDATE_CHECKER = "UPDATE_CHECKER"
export const DELETE_CHECKER = "DELETE_CHECKER"
export const SELECT_CHECKER = "SELECT_CHECKER"
